import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGetVideosQuery } from "../redux/features/videos/videosAPI";
import { useEditQuizMutation } from "../redux/features/quiz/quizAPI";
import Error from "./Error";

export default function EditQuizForm({ quiz }) {
  const {
    question: updateQuestion,
    video_id: updateVideoId,
    video_title: updateTitle,
    options: updateOptions,
    id,
  } = quiz;

  const {
    data: videos,
    isLoading: isVideoLoading,
    isError: isVideoError,
  } = useGetVideosQuery();

  let content;
  if (!isVideoLoading && !isVideoError) {
    content = videos.find(
      (video) => video.id === updateVideoId && video.title === updateTitle
    );
  } else content = {};

  const navigate = useNavigate();
  const [editQuiz, { isLoading, error }] = useEditQuizMutation();

  const [question, setQuestion] = useState(updateQuestion);
  const [video, setVideo] = useState(content);

  const [options1, setOptions1] = useState(updateOptions[0]);
  const [options2, setOptions2] = useState(updateOptions[1]);
  const [options3, setOptions3] = useState(updateOptions[2]);
  const [options4, setOptions4] = useState(updateOptions[3]);

  const handleSubmit = (e) => {
    e.preventDefault();
    editQuiz({
      id,
      data: {
        question,
        video_id: video.id,
        video_title: video.title,
        options: [options1, options2, options3, options4],
      },
    });

    navigate("/admin/quizzes");
  };

  return (
    <form className="mt-8 space-y-6" onSubmit={(e) => handleSubmit(e)}>
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          <div>
            <label
              htmlFor="video"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Associated Video
            </label>
            <select
              name="associatedVideo"
              required
              style={{
                color: "white",
                width: "100%",
                backgroundColor: "rgb(30 41 59 / var(--tw-bg-opacity))",
                height: "40px",
                fontSize: "0.875rem",
              }}
              className="px-3 rounded-md mt-1"
              onChange={(e) =>
                setVideo(videos.find((video) => video.title === e.target.value))
              }
            >
              {!isVideoLoading &&
                !isVideoError &&
                videos.map((video) => (
                  <option
                    key={video.id}
                    selected={video.title === updateTitle ? "selected" : null}
                  >
                    {video.title}
                  </option>
                ))}
            </select>
          </div>

          <br />
          <label
            htmlFor="title"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray"
          >
            Question
          </label>
          <input
            id="question"
            name="question"
            type="text"
            autoComplete="question"
            required
            className="login-input rounded-md mt-1"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
          />
        </div>

        <br />

        {/* options start here */}

        <label
          htmlFor="options"
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white pb-4"
        >
          Options
        </label>
        <div
          style={{
            display: "flex",
          }}
          onChange={(e) =>
            setOptions1((prev) => ({
              id: 1,
              option: e.target.type === "text" ? e.target.value : prev.option,
              isCorrect:
                e.target.type === "checkbox" && e.target.checked ? true : false,
            }))
          }
        >
          <label htmlFor="Marks" className="sr-only">
            Options 1
          </label>
          <input checked={options1.isCorrect} type="checkbox" /> &nbsp;&nbsp;
          <input
            id="options"
            name="options 1"
            type="text"
            autoComplete="options 1"
            required
            className="login-input rounded-md"
            value={options1.option}
          />
        </div>

        <div
          style={{
            display: "flex",
          }}
          onChange={(e) =>
            setOptions2((prev) => ({
              id: 1,
              option: e.target.type === "text" ? e.target.value : prev.option,
              isCorrect:
                e.target.type === "checkbox" && e.target.checked ? true : false,
            }))
          }
        >
          <label htmlFor="Marks" className="sr-only">
            Options 2
          </label>
          <input checked={options2.isCorrect} type="checkbox" /> &nbsp;&nbsp;
          <input
            id="options"
            name="options 2"
            type="text"
            autoComplete="options 2"
            required
            className="login-input rounded-md mt-2"
            value={options2.option}
          />
        </div>

        <div
          style={{
            display: "flex",
          }}
          onChange={(e) =>
            setOptions3((prev) => ({
              id: 1,
              option: e.target.type === "text" ? e.target.value : prev.option,
              isCorrect:
                e.target.type === "checkbox" && e.target.checked ? true : false,
            }))
          }
        >
          <label htmlFor="Marks" className="sr-only">
            Options 3
          </label>
          <input checked={options3.isCorrect} type="checkbox" /> &nbsp;&nbsp;
          <input
            id="options"
            name="options 3"
            type="text"
            autoComplete="options 3"
            required
            className="login-input rounded-md mt-2"
            value={options3.option}
          />
        </div>

        <div
          style={{
            display: "flex",
          }}
          onChange={(e) =>
            setOptions4((prev) => ({
              id: 1,
              option: e.target.type === "text" ? e.target.value : prev.option,
              isCorrect:
                e.target.type === "checkbox" && e.target.checked ? true : false,
            }))
          }
        >
          <label htmlFor="Marks" className="sr-only">
            Options 4
          </label>
          <input checked={options4.isCorrect} type="checkbox" /> &nbsp;&nbsp;
          <input
            id="options"
            name="options 4"
            type="text"
            autoComplete="options 4"
            required
            className="login-input rounded-md mt-2"
            value={options4.option}
          />
        </div>
      </div>

      {/* options end here */}

      <div className="flex justify-end gap-x-2">
        <button
          type="submit"
          disabled={isLoading}
          className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
        >
          Update
        </button>

        <Link
          to="/admin/quizzes"
          type="submit"
          disabled={isLoading}
          className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Cancel
        </Link>
      </div>

      {error && <Error message={error} />}
    </form>
  );
}
